const type = 'SET_CARD';

const setCard = (data) => ({
  data,
  type,
});

export { type };
export default setCard;
